import Code from '@/components/dashboard/Code';
import ClientCode from '@/components/dashboard/ClientCode';
import SectionActions from '@/docs/SectionActions';
import Links from '@/docs/ExampleLinks';
import { useRef } from 'react'
import SEOMetadata from '@/components/SEOMetadata';
import DocHeading from '@/docs/DocHeading';

export default function FilingsAPIDoc() {
  const sectionRef = useRef(null);
  return (
    <div className="api-documentation space-y-8 lg:max-w-[calc(100vw-340px)] md:max-w-[calc(100vw-80px)] max-w-[calc(100vw-30px)] overflow-hidden md:overflow-visible pb-50">
      <SEOMetadata title="List Forms - Filings API" description="Query list forms data via the Filings API; request parameters, code examples and the response schema for the list forms endpoint."  canonicalUrl="https://axionquant.com/docs/03-fundamentals/filings/list-forms" />
      <DocHeading className="text-3xl font-bold text-gray-900 mb-4">List Forms - Filings API</DocHeading>
      
      <div className="space-y-12" ref={sectionRef}>
        {/* ========== 2. List Available Form Types ========== */}
        <div className="flex flex-col lg:flex-row lg:gap-8 max-w-[1600px]">
          <div className="flex-1 min-w-0 lg:pr-6 xl:pr-12">
            <div className="mb-6">
              <div className="flex flex-wrap items-center gap-4 mb-4">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                  GET
                </span>
                <code className="text-lg font-mono text-gray-800 bg-gray-50 px-3 py-1 rounded break-all">
                  /filings/list/forms
                </code>
              </div>
              <p className="text-gray-700 mb-6">
                Returns a flat array of supported SEC form type strings (including "all").
                This endpoint does not require any authentication or parameters and is useful
                for building dropdown menus or validating form type inputs.
              </p>
            </div>

            <Links links={['/filings/list/forms']} />

            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-900 mb-3">Response</h3>
              <p className="text-sm text-gray-700 mb-3">
                The response is a flat array of strings representing supported SEC form types.
                The first element is always <code className="text-xs">&quot;all&quot;</code> which can be used
                in other endpoints to include all form types.
              </p>
              <div className="space-y-3">
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-mono text-sm text-gray-800 mb-1">[0]</p>
                  <p className="text-sm text-gray-600"><code className="text-xs">&quot;all&quot;</code>, a wildcard for all form types</p>
                </div>
                <div className="border-l-4 border-blue-500 pl-4">
                  <p className="font-mono text-sm text-gray-800 mb-1">[1..n]</p>
                  <p className="text-sm text-gray-600">Individual SEC form codes (e.g., &quot;10-K&quot;, &quot;4&quot;, &quot;NPORT-P&quot;)</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="rounded-lg p-0 !pt-0 pb-4 lg:sticky lg:top-[12px]">
              <SectionActions sectionTitle="Available Forms" contentRef={sectionRef} />

              <h3 className="text-sm font-semibold mb-3">Available Forms</h3>
              <div className="mb-4">
                <p className="text-gray-400 text-xs mb-2">Request</p>
                <ClientCode id="filings/list/forms"></ClientCode>
              </div>
              <div>
                <p className="text-gray-400 text-xs mb-2">Response</p>
                <Code id="03-fundamentals/filings/00-list-forms"></Code>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
